export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./quotations.vue?vue&type=template&id=79445428&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/quotations.vue?vue&type=template&id=79445428&scoped=true
// module id = 2432
// module chunks = 31